import { configureStore } from "@reduxjs/toolkit";
import matterReducer from "../slice/Matterslice";
import matterDetailsReducer from "../slice/MatterDetailsSlice"; 
import authReducers from "../slice/AuthSlice";
import editPDFReducers from "../slice/PDFEditSlice";
import homeReducer from "../slice/HomeSlice";
import featureFlagReducer from "../slice/FeatureFlagsSlice";
import snackBarReducer from "../slice/SnackbarSlice";
import websocketReducer from "../slice/WebsocketSlice";
import mailIntakeReducer from "../slice/MailIntakeSlice";
import aiReducer from "../slice/AISlice";
import inboxReducer from "../slice/InboxSlice";
import categorizationReducer from "../slice/CategorizationSlice";
import documentClipboardReducer from "../slice/DocumentClipboardSlice";
import feeNoticesReducer from "../slice/FeeNoticeSlice";
import intakeReviewsReducer from "../slice/IntakeReviewSlice";
import matterActivityReducer from "../slice/MatterActivitySlice";
import alertsReducer from "../slice/AlertsSlice";
import externalFolderShareReducer from "../slice/ExternalFolderShareSlice";
import { websocketMiddleware } from "../middleware/websocketMiddleware"; 

const store = configureStore({
  reducer: {
    auth: authReducers,
    matter: matterReducer,
    matterDetails: matterDetailsReducer,
    matterActivity: matterActivityReducer,
    editPDF: editPDFReducers,
    home: homeReducer,
    featureFlags: featureFlagReducer,
    snackbar: snackBarReducer,
    websocket: websocketReducer,
    mailIntake: mailIntakeReducer,
    ai: aiReducer,
    inbox: inboxReducer,
    categorization: categorizationReducer,
    documentClipboard: documentClipboardReducer,
    feeNotices: feeNoticesReducer,
    intakeReviews: intakeReviewsReducer,
    alerts: alertsReducer,
    externalFolderShare: externalFolderShareReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(websocketMiddleware), 
});

export default store;